import { connect } from 'react-redux'
import TableDriverViewSessionHistoryOld from 'src/components/drivers/TableDriverViewSessionHistoryOld'
import { getDriverSessionList, getManyTripsPerOperator, getDriverCheckInCheckOutV1 } from '../../state/actions/drivers'
import { IStoreState, IDriverSessionFilters, IDriverSessionHistoryFilters } from '../../types'

export function mapStateToProps(state: IStoreState, ownProps: any) {
  return {
    ownProps,
    currentOrganizationId: state.organizations.currentOrgId,
    sessionHistory: Object.values(state.drivers.sessionHistory),
    isFetching: state.drivers.sessionRequest,
    error: state.drivers.sessionError,
    totalSessions: state.drivers.totalSessions
  }
}

export function mapDispatchToProps(dispatch: any) {
  return {
    getDriversSessionList: (filters: IDriverSessionFilters) => dispatch(getDriverSessionList(filters)),
    getCheckInCheckOut: (filters: IDriverSessionHistoryFilters) => {
      return getDriverCheckInCheckOutV1(filters)
    },
    getManyTripsPerOperator: (filters: IDriverSessionHistoryFilters) => {
      return getManyTripsPerOperator(filters)
    }
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(TableDriverViewSessionHistoryOld)



// WEBPACK FOOTER //
// ./src/containers/drivers/TableDriverViewSessionHistoryOld.ts